import { useState } from "react";
import { Api } from "../api/Api";
import { useErrorWebhook } from "./useErrorWebhook";

export const usePageLoad = () => {
  const { ErrorWebhookTrigger } = useErrorWebhook();
  const [calledOnce, setCalledOnce] = useState(false);

  const savePageLoad = async (
    visitor_parameters,
    data,
    message_type,
    page_name,
    query_string,
    visitor_data,
    additionalData = {}
  ) => {
    const response = await Api.post("api/v1/data-ingestion-pipeline", {
      visitor_parameters,
      ...(Object.keys(data).length != 0 && { data }),
      message_type,
      page_name,
      query_string,
      visitor_data,
      ...additionalData,
    }).catch(function (err) {
       const erroMessage = {
          serviceName: "LEAD PAGE STATUS : " + message_type,
          errorReason: err.message,
          errorCode: err.code,
          uuid: data?.uuid || visitor_parameters?.uuid || "",
        };
        ErrorWebhookTrigger(erroMessage);
      return {
        data: {
          status: "Success",
          error: true,
        },
      };
    });
    setCalledOnce(true);
    return response;
  };
  return { savePageLoad, calledOnce };
};
